export const ALL_ZERO_PHIN = "000000000";
